import React, { useState } from 'react';
import styled from 'styled-components';
import { font, Theme } from '../utils/themes';
import StyledText from './StyledComponents/StyledText';
import { StyledHorizontalLine } from './StyledComponents/Styledhr';
import { useTheme } from '../middleware/ThemeContext';

interface Tab {
    label: string;
    count?: number;
    content: React.ReactNode;
}

interface WidgetTabsCardProps {
    tabs: Tab[];
    defaultActive?: number;
    border?: string;
    tabFontSize?: string;
    paddingTop?: string;
    noBoxShadow?: boolean
}

const WidgetTabsCard: React.FC<WidgetTabsCardProps> = ({ tabs, defaultActive = 0, border, tabFontSize, paddingTop, noBoxShadow }) => {
    const { theme } = useTheme();
    const [activeIndex, setActiveIndex] = useState(defaultActive);

    return (
        <StyledContainer theme={theme} border={border} noBoxShadow={noBoxShadow}>
            {/* Header Tabs */}
            <CardHeader paddingTop={paddingTop}>
                <TabList>
                    {tabs.map((tab, index) => (
                        <TabButton
                            key={index}
                            isActive={index === activeIndex}
                            onClick={() => setActiveIndex(index)}
                            theme={theme}
                        >
                            <StyledText
                                fontSize={tabFontSize || '14px'}
                                fontWeight={700}
                                // textColor={index === activeIndex ? theme.CorporateTheme.colors.headerColor : theme.CorporateTheme.colors.secondary}
                                textColor={theme.CorporateTheme.colors.primary}

                            >
                                {tab.label}
                            </StyledText>
                            {tab.count !== undefined && (
                                <StyledText
                                    fontSize={tabFontSize || "14px"}
                                    fontFamily={font.lato}
                                    textColor={theme.CorporateTheme.colors.count}
                                >
                                    ({tab.count})
                                </StyledText>
                            )}
                        </TabButton>
                    ))}
                </TabList>
            </CardHeader>

            <StyledHorizontalLine theme={theme} />


            {/* Tab Content */}
            <CardBody>{tabs[activeIndex].content}</CardBody>
        </StyledContainer>
    );
};

const StyledContainer = styled.div<{ theme: Theme, border?: string, noBoxShadow?: boolean }>`
  width: 100%;
//   background-color: ${({ theme }) => theme.colors.contentBackground};
  border: ${({ border, theme }) => border ? border : `1px solid ${theme.CorporateTheme.colors.border}`};
  border-radius: 5px;
  box-shadow: ${({ noBoxShadow }) => noBoxShadow ? 'none' : '0px 2px 10px 0px #0000000D'};
`;

const CardHeader = styled.div<{ paddingTop?: string }>`
  padding: ${({ paddingTop }) => paddingTop || '20px'} 12px 0;
`;

const TabList = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
`;

const TabButton = styled.button<{ isActive: boolean; theme: Theme }>`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
  padding-bottom: 10px;
  cursor: pointer;
  border-bottom: ${({ isActive, theme }) =>
        isActive ? `2px solid ${theme.CorporateTheme.colors.primary}` : '2px solid transparent'};
`;

const CardBody = styled.div`
  padding: 15px 12px;
`;

export default WidgetTabsCard;
